import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"

export default function Select({ value, onChange, className, options }) {
    const { loading, query, response, pageType } = useAppState()

    return (
        <div className="ns-sortby ns-category-sort" style="float: right !important; position: relative;">
            <select
                className={`ns-selection-dropdown-menu ns-text-align-left ${className}`}
                value={value}
                onChange={onChange}
                style="width: 240px; display: block; max-width: unset !important;padding: .7em 1.5em;border: 1px solid #f2f2f2;font-size: 0.88em;font-weight: 500;"
            >
                {options.map(option => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    )
}